/**
 * Keys by which to fragment DenormalizedOrder objects to prevent exceeding
 * the Algolia max object size.
 *
 * NOTE: This list should only include keys that are used to store ByID references
 * to be split into separate collections and recombined when needed.
 */
export const denormalizedOrderFragmentationKeys = [
    'draftWaypoints',
];
/**
 * Max number of objects that should be stored in each fragment of a DenormalizedOrder
 */
export const DENORMALIZED_ORDER_FRAGMENT_SIZE = 6;
//# sourceMappingURL=denormalizedData.js.map